var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchNormalSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/search-normal_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 21.75C5.85 21.75 1.25 17.15 1.25 11.5C1.25 5.85 5.85 1.25 11.5 1.25C17.15 1.25 21.75 5.85 21.75 11.5C21.75 17.15 17.15 21.75 11.5 21.75ZM11.5 2.75C6.67 2.75 2.75 6.68 2.75 11.5C2.75 16.32 6.67 20.25 11.5 20.25C16.33 20.25 20.25 16.32 20.25 11.5C20.25 6.68 16.33 2.75 11.5 2.75Z",
    fill: "#555768"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 22.7504C21.81 22.7504 21.62 22.6804 21.47 22.5304L19.47 20.5304C19.18 20.2404 19.18 19.7604 19.47 19.4704C19.76 19.1804 20.24 19.1804 20.53 19.4704L22.53 21.4704C22.82 21.7604 22.82 22.2404 22.53 22.5304C22.38 22.6804 22.19 22.7504 22 22.7504Z",
    fill: "#555768"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormalSvg);
export default __webpack_public_path__ + "static/media/SearchNormalSvg.cba22cc2b222b5984572f544c34b27bf.svg";
export { ForwardRef as ReactComponent };